import { useLocation } from "react-router-dom";
import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import Header from "../../components/globals/Header";
import AvailabililityInput from "../../components/inputs/AvailabililityInput";
import CategoriesSelectInput from "../../components/inputs/CategoriesSelectInput";
import ImagesUploadInput from "../../components/inputs/ImagesUploadInput";
import ImageUploadInput from "../../components/inputs/ImageUploadInput";
import MultiSelectInput from "../../components/inputs/MultiSelectInput";
import NormalInput2 from "../../components/inputs/NormalInput2";
import SimpleDropdownInput3 from "../../components/inputs/SimpleDropdownInput3";
import VideoUploadInput from "../../components/inputs/VideoUploadInput";
import AddressModal from "../../components/modals/AddressModal";
import DiscountModal from "../../components/modals/DiscountModal";
import { usePlaceHooks } from "../../hooks/UsePlacesHooks";
import { useTranslation } from "../../languages";
import { useGoBack } from "../../utils";
import { types } from "../../dummyData";
const EditPlace = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const goBack = useGoBack();
  const {
    editPlaceData,
    setEditPlaceData,
    onPressEditPayBtn,
  } = usePlaceHooks(state);
  return (
    <div>
      <Container fluid>
        <Header title={t("myPlaces")} />
        <div
          style={{ minHeight: "50px" }}
          className="bg-white d-flex px-3  mb-4 align-items-center justify-content-between full-width"
        >
          <h5 className="f-7 color-primary-blue m-0 figma-font-h5">
            {editPlaceData?.title ?? t("editPlace")}
          </h5>
          <Button
            onClick={() => goBack()}
            className="standard-rounded-btn   py-2 inner-shadow-white"
          >
            {t("close")}
          </Button>
        </div>
        <Card className="border-none figma-card-radius p-0">
          <CardBody className="padding-top-42px padding-left-42px padding-right-42px">
            <Row
              style={{ "--bs-gutter-y": "1.5rem" }}
            // className=" justify-content-center"
            >
              <Col md={6}>
                <NormalInput2
                  placeholder={t("writeTitleForPlace")}
                  value={editPlaceData?.name}
                  setValue={(v) =>
                    setEditPlaceData((prev) => ({ ...prev, name: v }))
                  }
                  label={t("enterYourPlaceName")}
                />
              </Col>
              <Col md={6}>
                <MultiSelectInput
                  label={t("type")}
                  setValue={(v) =>
                    setEditPlaceData((prev) => ({ ...prev, types: v }))
                  }
                  options={types}
                  value={editPlaceData?.types ?? []}
                />
              </Col>
              <Col md={6}>
                <NormalInput2
                  type={"link"}
                  placeholder={t("writeReservationLinkHere")}
                  value={editPlaceData?.reservationLink}
                  setValue={(v) =>
                    setEditPlaceData((prev) => ({
                      ...prev,
                      reservationLink: v,
                    }))
                  }
                  label={t("reservationLink")}
                />
              </Col>
              <Col md={6}>
                <AvailabililityInput
                  label={t("availability")}
                  value={editPlaceData?.availability}
                  setAvailabilityValue={(v) =>
                    setEditPlaceData((prev) => ({
                      ...prev,
                      availability: v,
                    }))
                  }
                  t={t}
                />
              </Col>
              <Col md={6}>
                <DiscountModal
                  value={editPlaceData?.offers ?? []}
                  label={t("offeredDiscounts")}
                  setValue={(v) =>
                    setEditPlaceData((prev) => ({ ...prev, offers: v }))
                  }
                />
               
              </Col>
              <Col md={6}>
                <AddressModal
                  label={t("location")}
                  value={editPlaceData?.location}
                  setValue={(v) =>
                    setEditPlaceData((prev) => ({ ...prev, location: v }))
                  }
                />
              </Col>
              <Col md={6}>
                <NormalInput2
                  type={"text"}
                  value={editPlaceData?.companyName}
                  setValue={(v) =>
                    setEditPlaceData((prev) => ({
                      ...prev,
                      companyName: v,
                    }))
                  }
                  label={t("companyName")}
                  placeholder={t("writeCompanyNameHere")}
                />
              </Col>
              <Col md={6}>
                <AddressModal
                  label={t("billingAddress")}
                  title={t("addBillingAddress")}
                  value={editPlaceData?.billingAddress}
                  setValue={(v) =>
                    setEditPlaceData((prev) => ({
                      ...prev,
                      billingAddress: v,
                    }))
                  }
                />
              </Col>
              {/* <Col md={6}>
                <NormalInput2
                  type={"url"}
                  value={editPlaceData?.website}
                  setValue={(v) =>
                    setEditPlaceData((prev) => ({ ...prev, website: v }))
                  }
                  label={"Website Link"}
                  placeholder={"Write website link here"}
                />
              </Col> */}
              <Col md={6}>
                <Label
                  style={{ marginBottom: "0.5rem" }}
                  className="figma-input-label d-block"
                >
                  {t("genderPreference")}
                </Label>
                <SimpleDropdownInput3
                  placeholder={t("selectOption")}
                  options={[t("male"), t("female"),t("All")]}
                  value={editPlaceData?.genderPreference}
                  setValue={(v) =>
                    setEditPlaceData((prev) => ({
                      ...prev,
                      genderPreference: v,
                    }))
                  }
                />
              </Col>
              <Col md={12}>
                <CategoriesSelectInput
                  label={t("category")}
                  arrayValue={editPlaceData?.categories}
                  setArrayValue={(v) =>
                    setEditPlaceData((prev) => ({ ...prev, categories: v }))
                  }
                />
              </Col>
              <Col md={12}>
                <NormalInput2
                  label={t("enterDescription")}
                  type={"textarea"}
                  placeholder={t("writeDescriptionOfPlace")}
                  value={editPlaceData?.description ?? ""}
                  setValue={(v) =>
                    setEditPlaceData((prev) => ({
                      ...prev,
                      description: v,
                    }))
                  }
                />
              </Col>
              <Col md={12} xl={4}>
                <ImagesUploadInput
                  label={t("editPhotos")}
                  value={editPlaceData?.photos}
                  setValue={(v) =>
                    setEditPlaceData((prev) => ({ ...prev, photos: v }))
                  }
                  maxImages={4}
                />
              </Col>
              <Col xl={4} md={6}>
                <Label
                  className="figma-input-label d-block"
                  style={{ marginBottom: "0.9rem" }}
                >
                  {t("editVideo")}
                </Label>
                <div style={{ maxWidth: "250px" }}>
                  <VideoUploadInput
                    noPadding={true}
                    hideShadow={true}
                    id={"place-video"}
                    setValue={(v) =>
                      setEditPlaceData((prev) => ({ ...prev, videos: v }))
                    }
                    value={editPlaceData?.videos}
                  />
                </div>
              </Col>
              <Col xl={4} md={6}>
                <div className="mt-3  flex-wrap justify-content-end gap-2">
                  <Label
                    style={{ marginBottom: "0.9rem" }}
                    className="figma-input-label d-block"
                  >
                    {t("editMenu")}
                  </Label>
                  <div style={{ width: "100%", maxWidth: "200px" }}>
                    <ImageUploadInput
                      id={"place-menu"}
                      setValue={(v) =>
                        setEditPlaceData((prev) => ({
                          ...prev,
                          menuImages: v,
                        }))
                      }
                      value={editPlaceData?.menuImages}
                    />
                  </div>
                </div>
              </Col>
              <div className="mt-5 mb-2 text-center">
                <Button
                  style={{ maxWidth: "380px" }}
                  onClick={onPressEditPayBtn}
                  // onClick={() => setThankYouModalOpen(true)}
                  className="standard-rounded-btn full-width"
                >
                  {t("save")}
                </Button>
              </div>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};
export default EditPlace;
